import { useEffect, useState } from "react";
import { getSelectorsByUserAgent } from "react-device-detect";

export const useDetectDevice = (userAgent?: string) => {
  const [device, setDevice] = useState({ isMobile: false, isTablet: false, isBrowser: false, isAndroid: false, isIOS: false });

  useEffect(() => {
    const selectors = getSelectorsByUserAgent(userAgent ?? window.navigator.userAgent);
    console.log('getSelectorsByUserAgent(userAgent ?? window.navigator.userAgent)', selectors);
    setDevice(selectors);
  }, [userAgent])
  
  return device;
};

